import { IconCheck } from '../img'

const Step2 = () => {



    return (
        <>
            <div className="mt-10" >
                <span className="lbl-input-re-ni " style={{ fontWeight: 600 }}>Recuerda tener en cuenta estos puntos:</span>
            </div>
            <div className="mt-10 info-group">
                <IconCheck />
                <span className='lbl-input-re-ni '>Solicitar al cliente su documento de identidad vigente</span>
            </div>
            <div className="mt-10 info-group">
                <IconCheck />
                <span className='lbl-input-re-ni '>Tomar fotografías relacionadas al accidente, del entorno, panoramicas, de los daños causados y lesionados si los hubiese</span>
            </div>
            <div className="mt-10 info-group">
                <IconCheck />
                <span className='lbl-input-re-ni '>En caso de haber otros vehículos involucrados, solicitar a los conductores la información necesaria para tramitar reclamo como perjudicado, si llegase a ser declarado como tal en el Certificado de Tránsito emitido por la Policia Nacional</span>
            </div>
            <div className="mt-10 info-group">
                <IconCheck />
                <span className='lbl-input-re-ni '>Comunicarle al cliente que a su correo electrónico llegará toda la información que se ingrese en este formulario en cumplimiento con las normativas emitidas por la Superintendencia de Bancos y de otras Instituciones Financieras</span>
            </div>            
        </>
    )
}

export { Step2 }